// @flow

import React from 'react';

import { SelectItem } from '@zapier/common-components';

import type { SelectItemProps } from '@zapier/common-components';

/**
 * Renders the selected service in the section box.
 *
 * SelectItem expects the logo to be in selectedItem.logoClass,
 * so map selectedItem.key (the service key) to selectedItem.logoClass.
 */
const SelectionComponent = ({ selectedItem, ...props }: SelectItemProps) => {
  if (selectedItem) {
    selectedItem = {
      ...selectedItem,
      logoClass: selectedItem.key,
    };
  }
  return <SelectItem {...props} selectedItem={selectedItem} />;
};

export default SelectionComponent;
